// @ts-ignore
import type {IOrderState} from "@/store/states/IOrderState.interface";
import type {IPaymentMethod} from "@/interfaces/IPaymentMethod.interface";
import {ServiceTypes} from "../interfaces/enums/ServiceTypes.enum";

const order = {
    prefix: 'order.',
    namespaced: true,
    state: <IOrderState>{
        withDriver: false,
        roundTrip: false,
        serviceType: ServiceTypes.SERVICE_RENT,

        // Payment
        isInvoiceNeeded: false,
        paymentMethod: null,

        isCompanyOrder: false,

        // Company
        isCompanyFormValid: false,
        companyName: null,
        companyCode: null,
        companyTaxCode: null,
        companyAddress: null,

        // Customer
        isCustomerFormValid: false,
        fullName: null,
        phoneNumber: null,
        email: null,

        isRulesAgreement: false,

    },
    mutations: {
        INITIALIZE_ORDER_STATE(state: IOrderState): void {
            state['defaultState'] = {...state};

            for (const prop of Object.getOwnPropertyNames(state)) {
                if (['isCompanyFormValid', 'isCustomerFormValid', 'isRulesAgreement'].includes(prop)) {
                    state[prop] = false;
                    localStorage.setItem(order.prefix + prop, JSON.stringify(false));
                    continue;
                }

                let value = localStorage.getItem(order.prefix + prop);

                if (value) {
                    state[prop] = JSON.parse(value);
                }
            }
        },
        SET_STATE_PROP_VALUE(state: IOrderState, payload: {prop: string, value: any}[]): void {
            for (const obj of payload) {

                if (! state.hasOwnProperty(obj.prop)) {

                    console.error('Trying to set state prop that doesn\'t exist');
                    return;
                }
            }

            for (const obj of payload) {
                const prop = obj.prop;
                const value = obj.value;

                state[prop] = value;

                localStorage.removeItem(order.prefix + prop);

                if (value !== undefined) {
                    localStorage.setItem(order.prefix + prop, value ? JSON.stringify(value) : value);
                }
            }
        },
        CLEAR_STATE(state: IOrderState): void {
            for (const prop of Object.getOwnPropertyNames(state)) {
                localStorage.removeItem(order.prefix + prop);

                if (state.defaultState) {
                    state[prop] = state.defaultState[prop];
                }
            }
        }

    },
    actions: {
        updateIsInvoiceNeeded(context: any, bool: boolean): void {
            context.commit('SET_STATE_PROP_VALUE', [{prop: 'isInvoiceNeeded', value: bool}]);
        },
        updatePaymentMethod(context: any, paymentMethod: IPaymentMethod | null): void {
            const value = paymentMethod ? paymentMethod.key : null;

            context.commit('SET_STATE_PROP_VALUE', [{prop: 'paymentMethod', value}]);
        },
        updateFormData(context: any, formData: {prop: string, value: any}[]): void {
            context.commit('SET_STATE_PROP_VALUE', formData);
        },

        // Company
        setIsCompanyFormValid(context: any, bool: boolean): void {
            context.commit('SET_STATE_PROP_VALUE', [
                {prop: 'isCompanyFormValid', value: bool},
                {prop: 'companyName', value: null},
                {prop: 'companyCode', value: null},
                {prop: 'companyTaxCode', value: null},
                {prop: 'companyAddress', value: null},
            ]);
        },

        // Customer
        setIsCustomerFormValid(context: any, bool: boolean): void {
            context.commit('SET_STATE_PROP_VALUE', [
                {prop: 'isCustomerFormValid', value: bool},
                {prop: 'fullName', value: null},
                {prop: 'phoneNumber', value: null},
                {prop: 'email', value: null},
                {prop: 'isRulesAgreement', value: false},
            ]);
        },

        updateInitStates(context, data: {prop: string, value: any}[]): void {
            context.commit('SET_STATE_PROP_VALUE', data);
        },
    },
    getters: {

    }
}

export default order;